export default __webpack_public_path__ + "static/media/profileImg2.fdea4f08.png";